import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslocoDirective} from "@jsverse/transloco";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {EffectsModule} from "@ngrx/effects";
import {StoreModule} from "@ngrx/store";
import {CoreCommonModule} from "../../../../@core/common.module";
import {SharedModule} from "../shared/shared.module";
import {SaveFilterComponent} from "./components/save-filter/save-filter.component";
import {SavedFiltersComponent} from "./components/saved-filters/saved-filters.component";
import {SaveFilterApiService} from "./save-filter.api.service";
import {SavedListingFiltersEffects} from "./store/saved-filters.effects";
import {reducer} from "./store/saved-filters.reducers";
import {savedFiltersFeatureKey} from "./store/saved-filtes.config";


@NgModule({
    declarations: [
        SavedFiltersComponent,
        SaveFilterComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        CoreCommonModule,
        NgbModule,
        TranslocoDirective,
        StoreModule.forFeature(savedFiltersFeatureKey, reducer),
        EffectsModule.forFeature([SavedListingFiltersEffects]),
    ],
    exports:[
        SavedFiltersComponent,

    ],
    providers:[
        {
            provide:SaveFilterApiService,
            useClass:SaveFilterApiService
        }
    ]
})
export class SavedFiltersModule {
}
